import React from 'react';
import ShippingCard from './ShippingCard';

const ShippingHeader = ({ shippingTypes }) => {
    const activeCount = Object.values(shippingTypes?.activeTypes || {}).filter(Boolean).length;
    const hasCards = activeCount > 0;

    return (
        <div style={{
            backgroundColor: '#2D3277',
            padding: '8px 15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '1px'
        }}>
            <img src="/fundoazul2.png" alt="Integra MKP" style={{ height: '48px', width: 'auto', display: 'block' }} />

            <div style={{
                display: 'flex',
                gap: '20px',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flex: '0 1 auto'
            }}>
                {shippingTypes?.schedules?.flex && (
                    <ShippingCard
                        title="FLEX"
                        schedule={shippingTypes.schedules?.flex}
                        type="drop_off" 
                    />
                )}
                
                {shippingTypes?.schedules?.withdrawal && (
                    <ShippingCard
                        title="RETIRADA NO VENDEDOR"
                        schedule={shippingTypes.schedules?.withdrawal}
                        type="cross_docking"
                    />
                )}

                {shippingTypes?.schedules?.agency && (
                    <ShippingCard
                        title="AGÊNCIA"
                        schedule={shippingTypes.schedules?.agency}
                        type="xd_drop_off" 
                    />
                )}
            </div>
        </div>
    );
};

export default ShippingHeader;